import { BlotterMonoDatePicker } from 'components/shared/DatePicker';
import { FC } from 'react';

interface AdvancedDateFilterProps {
  startDate?: string;
  endDate?: string;
  onStartDateFilterChanged(date: Nullable<string>): void;
  onEndDateFilterChanged(date: Nullable<string>): void;
}

export const AdvancedDateFilter: FC<AdvancedDateFilterProps> = ({
  startDate,
  onStartDateFilterChanged,
  endDate,
  onEndDateFilterChanged,
}) => {
  return (
    <>
      <div className="filter-from-date-picker">
        <BlotterMonoDatePicker
          disabled={false}
          size="xl"
          allowWeekend
          isClearable={false}
          id="quote-blotter-filter-date-start"
          value={startDate}
          onChange={onStartDateFilterChanged}
        />
      </div>
      <i className="icon mx-3 align-content-center">arrow_forward</i>
      <div className="filter-to-date-picker">
        <BlotterMonoDatePicker
          disabled={false}
          size="xl"
          align="end"
          allowWeekend
          isClearable={false}
          id="quote-blotter-filter-date-end"
          value={endDate}
          onChange={onEndDateFilterChanged}
        />
      </div>
    </>
  );
};
